module.exports = __webpack_public_path__ + "img/slide_03.268839ed.png";